"use strict";

globalThis.Hologram.pendingScripts ??= [];

globalThis.Hologram.pendingScripts.push({
  digest: new URL(document.currentScript.src).pathname.match(/-([^-]+)\.js$/)[1],
  define: (deps) => {
    const {
      Bitstring,
      ERTS,
      HologramBoxedError,
      HologramInterpreterError,
      Interpreter,
      MemoryStorage,
      Type,
      Utils,
    } = deps;

Interpreter.defineElixirFunction("Ecto.Schema.Metadata", "__struct__", 0, "public", [{params: (context) => [], guards: [], body: (context) => {
return Type.map([[Type.atom("__struct__"), Type.atom("Elixir.Ecto.Schema.Metadata")], [Type.atom("context"), Type.atom("nil")], [Type.atom("prefix"), Type.atom("nil")], [Type.atom("schema"), Type.atom("nil")], [Type.atom("source"), Type.atom("nil")], [Type.atom("state"), Type.atom("nil")]]);
}}]);

Interpreter.defineElixirFunction("Ecto.Schema.Metadata", "__struct__", 1, "public", [{params: (context) => [Type.variablePattern("kv_0")], guards: [], body: (context) => {
return Elixir_Enum["reduce/3"](context.vars.kv_0, Type.map([[Type.atom("__struct__"), Type.atom("Elixir.Ecto.Schema.Metadata")], [Type.atom("context"), Type.atom("nil")], [Type.atom("prefix"), Type.atom("nil")], [Type.atom("schema"), Type.atom("nil")], [Type.atom("source"), Type.atom("nil")], [Type.atom("state"), Type.atom("nil")]]), Type.anonymousFunction(2, [{params: (context) => [Type.tuple([Type.variablePattern("key_1"), Type.variablePattern("val_2")]), Type.variablePattern("map_3")], guards: [], body: (context) => {
return Elixir_Map["merge/2"](context.vars.map_3, Type.map([[context.vars.key_1, context.vars.val_2]]));
}}], context, "-__struct__/1-fun-0-"));
}}]);
  },
});

document.dispatchEvent(new CustomEvent("hologram:scriptLoaded"));